import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import {
  AiFillGithub,
  AiFillMail,
  AiFillInstagram,
  AiFillLinkedin
} from "react-icons/ai";
import { FaFeatherAlt } from "react-icons/fa";

function FindMe(){
  return (
    <Container fluid className="home-about-section" id="about">
      <Container>
        <Row>
          <Col md={12} className="home-about-social">
            <ul className="home-about-social-links">
              <li className="social-icons">
                <a
                    href="https://www.anleeno.com"
                    target="_blank"
                    rel="noreferrer"
                    aria-label="Academic website"
                    className="icon-colour  home-social-icons"
                >
                  <FaFeatherAlt />
                </a>
              </li>
              <li className="social-icons">
                <a
                    href="https://github.com/anleeno"
                    target="_blank"
                    rel="noreferrer"
                    className="icon-colour  home-social-icons"
                >
                  <AiFillGithub />
                </a>
              </li>
              <li className="social-icons">
                <a
                    href="https://www.instagram.com/anleeno_ss"
                    target="_blank"
                    rel="noreferrer"
                    className="icon-colour  home-social-icons"
                >
                  <AiFillInstagram />
                </a>
              </li>
              <li className="social-icons">
                <a
                    href="https://www.linkedin.com/in/anleeno0805"
                    target="_blank"
                    rel="noreferrer"
                    className="icon-colour  home-social-icons"
                >
                  <AiFillLinkedin />
                </a>
              </li>
              <li className="social-icons">
                <a
                    href="mailto:xushubo0805@gmail.com"
                    target="_blank"
                    rel="noreferrer"
                    className="icon-colour  home-social-icons"
                >
                  <AiFillMail />
                </a>
              </li>
            </ul>
          </Col>
        </Row>
    </Container>
    </Container>
  );
}
export default FindMe;
